module.exports = __webpack_public_path__ + "img/HourglassEmptyOutlined.2e671d82.svg";